export default function () {
  const domain = "";
  return {
    domain: domain,
    chukul: "chukul.com",
    sweta: "sweta.nepsesignal.com",
    globalimecapital: "nepsesignal.com",
    demo: "demo.nepsesignal.com",
    demo1: "demo1.nepsesignal.com",
    prabhu: "broker.nepsesignal.com",
    arthasarokar: "stock.arthasarokar.com",
    dev: "developer.chukul.com",
  };
}
